import {getLoginUrl} from "@project/application";

export function startDefaultLogin() {
  window.location.assign(getLoginUrl("/"));
}
